import { render, staticRenderFns } from "./LoginPageWithTitleSection.vue?vue&type=template&id=b0b9c72c&scoped=true&"
import script from "./LoginPageWithTitleSection.vue?vue&type=script&lang=ts&"
export * from "./LoginPageWithTitleSection.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPageWithTitleSection.vue?vue&type=style&index=0&id=b0b9c72c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9c72c",
  null
  
)

export default component.exports